import { TextareaAutosize } from "@mui/base/TextareaAutosize";
import React from "react";

const fieldsWhereMinRowsIsThree = [
  "subjective",
  "objective",
  "assessment",
  "plan",
  "additionalNotes",
];

const fieldsWhereMinRowsIsTen = ["customText"];

export default function PredictiveInput({
  inputClassName,
  placeholder,
  field,
  onMouseUp = null,
  disabled = false,
  isStreaming = false,
}) {
  function getMinRows() {
    if (fieldsWhereMinRowsIsThree.includes(field.name)) {
      return 3;
    } else if (fieldsWhereMinRowsIsTen.includes(field.name)) {
      return 26;
    }
    return 0;
  }

  return (
    <div id="input-predict-container" className="relative w-full">
      <TextareaAutosize
        minRows={getMinRows()}
        value={field.value ?? ""}
        id="input-predict-input"
        className={inputClassName}
        onChange={(e) => field.onChange(e.target.value)}
        placeholder={isStreaming ? "" : placeholder}
        onMouseUp={onMouseUp}
        disabled={disabled}
        data-testid={`${field.name}-input`}
      />
    </div>
  );
}
